// Threat types configuration for API manager
export const getDefaultThreatTypes = () => [
  { category: "SECURITY", event: "Earthquake" },
  { category: "CBRNE", event: "Earthquake" },
];

// Available threat categories
export const THREAT_CATEGORIES = ["GEO", "SECURITY", "CBRNE", "MET", "OTHER"];

// Available threat events
export const THREAT_EVENTS = [
  "Missile",
  "UAV",
  "Radiological",
  "Earthquake",
  "EarthquakeVast",
  "terrorist attack",
  "Tsunami",
  "Hazardous Materials",
  "interception pieces",
  "Silent Alert",
  "Kill",
  "NonUrgentInfo",
  "UrgentInfo",
];
